/**
 * Mode transitions the travel modes share (plan R17): cancelling a charge, and dropping out of cruise into normal
 * flight (§2.9 flows 4–5): the velocity points along the nose at the drop speed, the ship reattaches (recentred on it),
 * the drive cools down and `REV.cruiseDrop` carries the reason. Rare events.
 */
import { emitReach, REV } from '../../reach/events'
import type { ReachCore } from '../../reach/runtime/types'
import { attachShip, type Sim } from '../../sim'
import { Pos64, Vel } from '../../world/components'
import { CHARGE, type TravelRuntime } from './state'

/** Drops out of cruise (or a tug) with `REV.cruiseDrop` reason `reason` (`DROP`), at `speedAfter`, cooling `cooldownS`. */
export function dropOut(rt: TravelRuntime, core: ReachCore, sim: Sim, eid: number, reason: number, speedAfter: number, cooldownS: number): void {
  const t = core.travel
  const n = rt.nose
  Vel.x[eid] = n.x * speedAfter
  Vel.y[eid] = n.y * speedAfter
  Vel.z[eid] = n.z * speedAfter
  attachShip(sim, eid)
  t.mode = 'normal'
  t.speed = speedAfter
  t.allowed = 0
  t.etaS = 0
  t.cooldownS = cooldownS
  const it = t.interdiction
  it.active = false
  it.escape = 0
  it.pull = 0
  it.timeLeftS = 0
  emitReach(core.events, REV.cruiseDrop, 0, reason, Pos64.x[eid], Pos64.y[eid], Pos64.z[eid], 0)
}

/** Cancels a charge: back to normal flight, `REV.cruiseCharge` (cancel). */
export function cancelCharge(core: ReachCore, eid: number): void {
  const t = core.travel
  t.mode = 'normal'
  t.chargeS = 0
  emitReach(core.events, REV.cruiseCharge, CHARGE.cancel, 0, Pos64.x[eid], Pos64.y[eid], Pos64.z[eid], 0)
}
